import { render, staticRenderFns } from "./d-leaderboard-feed-entry-badge.vue?vue&type=template&id=6435947c&scoped=true&"
import script from "./d-leaderboard-feed-entry-badge.vue?vue&type=script&lang=js&"
export * from "./d-leaderboard-feed-entry-badge.vue?vue&type=script&lang=js&"
import style0 from "./d-leaderboard-feed-entry-badge.vue?vue&type=style&index=0&id=6435947c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435947c",
  null
  
)

export default component.exports